
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqjjKwHwl3gHPshJy6Fwl0mtVaKy4g6wmpINdRy4T3GwoMeta } from "/vercel/path0/pages/faq.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as hotelsixslakNR952xZUezsSCggQc3a7mIn_45PZW5jw513G7WQMeta } from "/vercel/path0/pages/hotels.vue?macro=true";
import { default as contact6cZoOGxJBTY9l_45DSf37OWQKprIBU1PffJx7PVn14dCsMeta } from "/vercel/path0/pages/contact.vue?macro=true";
import { default as galleryDLxFKVENimRRVJJ_459ELiRq_45VfjTVrdrzneLKnokQEnkMeta } from "/vercel/path0/pages/gallery.vue?macro=true";
import { default as sitemapnpadVI10GvN_45Y_45o1so1bwWJcyYretVyWs_xkYJE7aFUMeta } from "/vercel/path0/pages/sitemap.vue?macro=true";
import { default as _91_46_46_46page_93B6221gClypHIxjPWduJSW1WcqVmtTSAgv2lPPCKtC3oMeta } from "/vercel/path0/pages/[...page].vue?macro=true";
import { default as apartmentsoCbpc84eVqTwKfKUMo__45ITIGWrMOoS7eg4JwgCeyTlQMeta } from "/vercel/path0/pages/apartments.vue?macro=true";
import { default as restaurantsGVa7frQMqt24iZ1QaBKDUL1wf_ktKt_EB7iKK_45eM6RwMeta } from "/vercel/path0/pages/restaurants.vue?macro=true";
import { default as indexC2PrQsHNIh2_Na1GMHHyln_45n1Pvl41h3pwdT50aMmo0Meta } from "/vercel/path0/pages/magazine/index.vue?macro=true";
import { default as indexZn_45bAcd39gGp3B0BjAFVKy86eJy9pe0_68j0ApHVaqMMeta } from "/vercel/path0/pages/packages/index.vue?macro=true";
import { default as contact_45successE_iLDmXw_454NiRsWqicdCk43PozxFS8lHipwYsVP1FY0Meta } from "/vercel/path0/pages/contact-success.vue?macro=true";
import { default as _91item_93dV2eLPx_QkouGmPsNc_W3jXiEtLlFZG27ORIO1h_454E0Meta } from "/vercel/path0/pages/magazine/[item].vue?macro=true";
import { default as _91item_939C8kULePuMOZkF6y8V95ZLVBcRP1Lk2y8Tk8ECdGARwMeta } from "/vercel/path0/pages/packages/[item].vue?macro=true";
import { default as indexKmjwSzq9GaAAk3Ey8PsdYuMIJhhwCqzoHwjXqVD_YWMMeta } from "/vercel/path0/pages/vacancies/index.vue?macro=true";
import { default as _91item_93hh_00XwaGPAQLiyctzWT0PTXCTH4h86sL6TLOX52aqYMeta } from "/vercel/path0/pages/vacancies/[item].vue?macro=true";
export default [
  {
    name: "faq___nl",
    path: "/veelgestelde-vragen",
    component: () => import("/vercel/path0/pages/faq.vue")
  },
  {
    name: "faq___en",
    path: "/en/faq",
    component: () => import("/vercel/path0/pages/faq.vue")
  },
  {
    name: "index___nl",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "hotels___nl",
    path: "/hotels",
    component: () => import("/vercel/path0/pages/hotels.vue")
  },
  {
    name: "hotels___en",
    path: "/en/hotels",
    component: () => import("/vercel/path0/pages/hotels.vue")
  },
  {
    name: "contact___nl",
    path: "/contact",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "gallery___nl",
    path: "/galerie",
    component: () => import("/vercel/path0/pages/gallery.vue")
  },
  {
    name: "gallery___en",
    path: "/en/gallery",
    component: () => import("/vercel/path0/pages/gallery.vue")
  },
  {
    name: "sitemap___nl",
    path: "/sitemap",
    component: () => import("/vercel/path0/pages/sitemap.vue")
  },
  {
    name: "sitemap___en",
    path: "/en/sitemap",
    component: () => import("/vercel/path0/pages/sitemap.vue")
  },
  {
    name: "page___nl",
    path: "/:page(.*)*",
    component: () => import("/vercel/path0/pages/[...page].vue")
  },
  {
    name: "page___en",
    path: "/en/:page(.*)*",
    component: () => import("/vercel/path0/pages/[...page].vue")
  },
  {
    name: "apartments___nl",
    path: "/appartementen",
    component: () => import("/vercel/path0/pages/apartments.vue")
  },
  {
    name: "apartments___en",
    path: "/en/apartments",
    component: () => import("/vercel/path0/pages/apartments.vue")
  },
  {
    name: "restaurants___nl",
    path: "/restaurants",
    component: () => import("/vercel/path0/pages/restaurants.vue")
  },
  {
    name: "restaurants___en",
    path: "/en/restaurants",
    component: () => import("/vercel/path0/pages/restaurants.vue")
  },
  {
    name: "magazine___nl",
    path: "/vondel-magazine",
    component: () => import("/vercel/path0/pages/magazine/index.vue")
  },
  {
    name: "magazine___en",
    path: "/en/vondel-magazine",
    component: () => import("/vercel/path0/pages/magazine/index.vue")
  },
  {
    name: "packages___nl",
    path: "/arrangementen",
    component: () => import("/vercel/path0/pages/packages/index.vue")
  },
  {
    name: "packages___en",
    path: "/en/special-offers",
    component: () => import("/vercel/path0/pages/packages/index.vue")
  },
  {
    name: "contact-success___nl",
    path: "/contact-form-success",
    component: () => import("/vercel/path0/pages/contact-success.vue")
  },
  {
    name: "contact-success___en",
    path: "/en/contact-form-success",
    component: () => import("/vercel/path0/pages/contact-success.vue")
  },
  {
    name: "magazine-item___nl",
    path: "/vondel-magazine/:item()",
    component: () => import("/vercel/path0/pages/magazine/[item].vue")
  },
  {
    name: "magazine-item___en",
    path: "/en/vondel-magazine/:item()",
    component: () => import("/vercel/path0/pages/magazine/[item].vue")
  },
  {
    name: "packages-item___nl",
    path: "/arrangementen/:item()",
    component: () => import("/vercel/path0/pages/packages/[item].vue")
  },
  {
    name: "packages-item___en",
    path: "/en/special-offers/:item()",
    component: () => import("/vercel/path0/pages/packages/[item].vue")
  },
  {
    name: "vacancies___nl",
    path: "/jobs",
    component: () => import("/vercel/path0/pages/vacancies/index.vue")
  },
  {
    name: "vacancies___en",
    path: "/en/jobs",
    component: () => import("/vercel/path0/pages/vacancies/index.vue")
  },
  {
    name: "vacancies-item___nl",
    path: "/jobs/:item()",
    component: () => import("/vercel/path0/pages/vacancies/[item].vue")
  },
  {
    name: "vacancies-item___en",
    path: "/en/jobs/:item()",
    component: () => import("/vercel/path0/pages/vacancies/[item].vue")
  }
]